import ScrollReveal from "scrollreveal";

const scrollReveal = ScrollReveal();

function getInlineConfig(el) {
    const { scrollRevealConfig } = el.dataset;
    return scrollRevealConfig && JSON.parse(scrollRevealConfig);
}

function initScroll(el, options) {
    if (el.classList.contains(".mix") && el.style.display === "none") {
        // This will stop mixitup hidden elements (with class 'mix') being show by scroll-reveal when hidden;
        return;
    }
    scrollReveal.reveal(el, getInlineConfig(el) || options);
}

export default {
    init: () => {
        // Generic reveal
        document.querySelectorAll(".scroll-reveal").forEach(initScroll);

        document.querySelectorAll(".xx").forEach(function (el) {
            scrollReveal.reveal(
                el,
                {
                    duration: 600,
                    distance: "20px",
                    easing: "ease-out",
                    origin: "bottom",
                    scale: 1,
                    reset: true,
                    afterReveal: function () {
                        scrollReveal.reveal(
                            ".xx",
                            {
                                duration: 900,
                                scale: 1,
                                distance: "80px",
                                origin: "bottom",
                                easing: "ease-out",
                                reset: true
                            },
                            75
                        );
                    }
                },
                150
            );
        });



        document.querySelectorAll(".staff_member").forEach(initScroll);

    },
    cleanup: () => ScrollReveal().destroy()
};
